
import { Helmet } from "react-helmet";
import AboutUpdated from "@/components/AboutUpdated";

import MainLayout from "@/components/layout/MainLayout";
import BackButton from "@/components/common/BackButton";

const About = () => {
  return (
    <>
      <Helmet>
        <title>O nas - 061 Garage Poznań Wilda | Profesjonalny Team</title>
        <meta 
          name="description" 
          content="Poznaj zespół 061 Garage Poznań Wilda - eksperci detailingu z wieloletnim doświadczeniem. Profesjonalizm, jakość, mobilność. Umów się: 602 709 327" 
        />
        <meta name="keywords" content="o nas 061 garage, detailing Poznań Wilda, profesjonalny zespół, doświadczenie detailing, autodetailing Poznań, detailing studio Poznań" />
        <link rel="canonical" href="https://061garagedetailingstudio.pl/o-nas" />
        <meta property="og:title" content="O nas - 061 Garage Poznań Wilda | Profesjonalny Team" />
        <meta property="og:description" content="Poznaj zespół ekspertów detailingu z Poznania. Wieloletnie doświadczenie, mobilny serwis. Zadzwoń: 602 709 327" />
        <meta property="og:url" content="https://061garagedetailingstudio.pl/o-nas" />
        <meta property="og:image" content="https://061garagedetailingstudio.pl/lovable-uploads/5f17a190-693b-4d81-b673-957c3b473247.png" />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="pl_PL" />
        <meta property="og:site_name" content="061 Garage Detailing Studio" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="O nas - 061 Garage Poznań Wilda | Profesjonalny Team" />
        <meta name="twitter:description" content="Poznaj zespół ekspertów detailingu z Poznania. Wieloletnie doświadczenie, mobilny serwis. Zadzwoń: 602 709 327" />
        <meta name="twitter:image" content="https://061garagedetailingstudio.pl/lovable-uploads/5f17a190-693b-4d81-b673-957c3b473247.png" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "AboutPage",
            "mainEntity": {
              "@type": "LocalBusiness",
              "name": "061 Garage Detailing Studio",
              "description": "Profesjonalne usługi detailingu samochodowego w Poznaniu"
            }
          })}
        </script>
      </Helmet>
      <BackButton />
      <MainLayout>
        <div className="pt-24 md:pt-28">
          <AboutUpdated />
        </div>
      </MainLayout>
    </>
  );
};

export default About;
